/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseControl from 'scripts/base-control';
import appContext from 'scripts/app-context';
import popupView from 'blocks/partner-link/partner-link-popup.stache';

export const PartnerLink = BaseControl.extend({
    init: function(element, options) {
        this._super(element, options);
        this.data = options.data;
    },

    click: function($el, ev) {
        ev.preventDefault();

        this.$('body').append(
            popupView(
                this.can.extend(
                    {
                        destroy: () => {
                            if (this.$popup) {
                                this.$popup.remove();
                            }
                        },
                        inserted: (el) => {
                            this.$popup = $(el);
                            this.$popup.toggleClass('is-visible', true);
                            appContext.model.dispatch('page-scroll-toggle', [
                                true,
                            ]);
                        },
                        close: function() {
                            appContext.model.dispatch('page-scroll-toggle', [
                                false,
                            ]);
                            this.destroy();
                        },
                    },
                    this.data,
                ),
            ),
        );
    },
});
